import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// CloudFront 320x320 product thumbnails — single source for all product tiles.
export const PRODUCT_THUMB_CDN =
  'https://d22u7e6casvzfe.cloudfront.net/uploads/products/320x320/';

/**
 * Product tile thumbnail. Relies on Porto theme figure sizing
 * (figure::before padding-top 100% + absolute img + object-fit: cover).
 * Do not wrap in an extra aspect-ratio box — that stretches images.
 */
function ProductImage({
  image,
  alt = '',
  wrapperClassName = '',
  threshold = 500,
  effect = 'black and white',
  ...rest
}) {
  const filename =
    typeof image === 'string'
      ? image
      : image?.product_image || '';
  const resolvedAlt =
    alt ||
    (typeof image === 'object' && image?.product_image_alt) ||
    'product';
  const src = filename.startsWith('http')
    ? filename
    : PRODUCT_THUMB_CDN + filename;

  return (
    <LazyLoadImage
      alt={resolvedAlt}
      src={src}
      threshold={threshold}
      effect={effect}
      wrapperClassName={wrapperClassName || undefined}
      {...rest}
    />
  );
}

export default ProductImage;
